import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslocoDirective } from '@jsverse/transloco';
import { BaseModalComponent } from '../base-modal/base-modal/base-modal.component';

export type MissingInformationAction = 'submit' | 'continue';

@Component({
  selector: 'ld-missing-information-modal',
  imports: [BaseModalComponent, MatProgressSpinnerModule, TranslocoDirective],
  templateUrl: './missing-information-modal.component.html',
  styleUrl: './missing-information-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MissingInformationModalComponent {
  missingPagesCount = input<number>(0);

  isLoading = input<boolean>(false);

  submitAction = output<void>();

  continueAction = output<void>();

  closeAction = output<void>();

  protected onSubmit(): void {
    if (!this.isLoading()) {
      this.submitAction.emit();
    }
  }

  protected onContinue(): void {
    if (!this.isLoading()) {
      this.continueAction.emit();
    }
  }

  protected onBackdropClick(event: MouseEvent): void {
    if (event.target === event.currentTarget && !this.isLoading()) {
      this.closeAction.emit();
    }
  }
}
